import BeleefSubscriptions from "components/subscriptions/BeleefSubscription";
import CommunitySubscription from "components/subscriptions/CommunitySubscription";
import SocialSubscription from "components/subscriptions/SocialSubscription";
import CompanySubscription from "components/subscriptions/CompanySubscription";
import React, { useState } from "react";

const TABS = [
  {
    id: "beleef",
    label: "Beleef",
    component: BeleefSubscriptions,
  },
  {
    id: "community",
    label: "Community",
    component: CommunitySubscription,
  },
  {
    id: "social",
    label: "Social",
    component: SocialSubscription,
  },
  {
    id: "company",
    label: "Company",
    component: CompanySubscription,
  },
];

const TabButton = ({ tab, isActive, onClick }) => {
  const baseClasses =
    "whitespace-nowrap py-2 px-2.5 border-b-2 font-medium text-sm transition-colors";
  const activeClasses = "border-black text-black";
  const inactiveClasses =
    "border-transparent text-darkgray hover:text-darkergray hover:border-lightgray";

  return (
    <button
      onClick={() => onClick(tab.id)}
      className={`${baseClasses} ${isActive ? activeClasses : inactiveClasses}`}
      aria-selected={isActive}
      role="tab"
    >
      {tab.label}
    </button>
  );
};

const Subscriptions = () => {
  const [activeTab, setActiveTab] = useState(TABS[0].id);

  const activeTabData = TABS.find((tab) => tab.id === activeTab) || TABS[0];
  const ActiveComponent = activeTabData.component;

  return (
    <>
      <div className="container mx-auto space-y-4">
        <h4>Subscriptions</h4>

        <div className="border-b border-lightgray">
          <nav className="-mb-px flex overflow-auto" role="tablist">
            {TABS.map((tab) => (
              <TabButton
                key={tab.id}
                tab={tab}
                isActive={activeTab === tab.id}
                onClick={setActiveTab}
              />
            ))}
          </nav>
        </div>
      </div>

      <div role="tabpanel">
        <ActiveComponent />
      </div>
    </>
  );
};

export default Subscriptions;